import { Panel } from "@amber/ui";
import type { ReactNode } from "react";
import type { BudgetsResponse } from "../../contracts/index";
import { usd } from "./money";
import { Name, Table, Td, Th } from "./parts";

export function ThresholdsPanel({ data }: { data: BudgetsResponse }) {
  const t = data.thresholds;
  const rows: { term: string; value: ReactNode; text: string; effect: string }[] = [
    {
      term: "Alert",
      value: (
        <>
          At <b>{t.alert_percent}%</b> spent and committed
        </>
      ),
      text: "Marks the category here and on Home, shows the budget banner to Admins on every page and opens a Budget alert task for Admins.",
      effect: t.effects.alert,
    },
    {
      term: "Suspend optional work",
      value: (
        <>
          At <b>{t.suspend_percent}%</b>
        </>
      ),
      text: "History extension, gap backfill, reprocessing and optional checks pause; fresh monitoring continues.",
      effect: t.effects.suspend,
    },
    {
      term: "Stop optional commitments",
      value: (
        <>
          Before projected commitments reach <b>{t.stop_percent}%</b>
        </>
      ),
      text: "No new optional work is admitted; the essential-service policy below applies and overruns stay visible.",
      effect: t.effects.stop,
    },
  ];
  return (
    <Panel title="Thresholds" note="applied to every category and the total">
      <dl className="m-0 grid grid-cols-[150px_minmax(0,1fr)] gap-x-3 gap-y-2 text-ui max-narrow:grid-cols-1 max-narrow:gap-y-0.5">
        {rows.map((r) => (
          <div key={r.term} className="contents">
            <dt className="text-muted max-narrow:mt-1.5">{r.term}</dt>
            <dd className="m-0 min-w-0 text-fg [&_b]:font-semibold">
              {r.value}
              <span className="block text-md text-muted">
                {r.text} {r.effect}
              </span>
            </dd>
          </div>
        ))}
      </dl>
    </Panel>
  );
}

export function LimitsPanel({ data }: { data: BudgetsResponse }) {
  const l = data.limits;
  return (
    <Panel title="Limits">
      <Table
        label="Limits"
        head={
          <>
            <Th>Limit</Th>
            <Th right>Value</Th>
            <Th>Now</Th>
          </>
        }
      >
        <tr>
          <Td>
            <Name>Daily spend</Name>
          </Td>
          <Td right className="tabular-nums text-fg">
            {usd(l.daily.value)}
          </Td>
          <Td>{l.daily.effect}</Td>
        </tr>
        <tr>
          <Td>
            <Name>Per job</Name>
          </Td>
          <Td right className="tabular-nums text-fg">
            {usd(l.per_job.value)}
          </Td>
          <Td>{l.per_job.effect}</Td>
        </tr>
        <tr>
          <Td>
            <Name detail="History extension and gap backfill">Backfill share</Name>
          </Td>
          <Td right className="tabular-nums text-fg">
            {l.backfill.percent}%
          </Td>
          <Td>
            {usd(l.backfill.used)} of {usd(l.backfill.value)} this month
          </Td>
        </tr>
      </Table>
    </Panel>
  );
}
